import { useGlobalState } from '@exodus/headless-react';
const usePrefilledAmountId = () => {
    return useGlobalState({
        namespace: 'exchange',
        key: 'prefilledAmountId',
        defaultValue: null,
    });
};
export default usePrefilledAmountId;
